import { PayloadAction } from '@reduxjs/toolkit';

import { PreviewState } from 'editor/src/store/editorModules/preview/types';

const setThe3dPreviewAvailableReducer = (state: PreviewState, action: PayloadAction<boolean>) => {
  state.the3dPreviewAvailable = action.payload;
};

export default setThe3dPreviewAvailableReducer;
